<script setup lang="ts">
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import PartnerCommentEdit from '@/components/features/partners/PartnerCommentEdit.vue'
import PartnerEnv from './PartnerEnv.vue'
import PartnerCallsAndEvents from './PartnerCallsAndEvents.vue'
import PartnerContactDetails from '@/components/features/partners/PartnerContactDetails.vue'
import PartnerAttribution from '@/components/features/partners/PartnerAttribution.vue'
import CallCreate from '@/components/features/calls/CallCreate.vue'
const partnerStore = usePartnerStore()

const { partner } = storeToRefs(partnerStore)
</script>

<template>
  <div class="grid grid-cols-12 gap-4">
    <PartnerContactDetails v-if="partner" class="col-span-5" />
    <div class="col-span-7 flex flex-col w-full gap-2">
      <p class="font-bold">
        Notes:
        <PartnerCommentEdit v-if="partner" :partner="partner" />
      </p>
      <div class="bg-base-200 p-4 rounded-lg w-full" v-html="partner?.comment || ''"></div>
    </div>
    <div class="col-span-12">
      <partner-attribution />
    </div>
    <div class="flex col-span-12" v-if="partner">
      <div class="flex-1">
        <div class="bg-background text-primary p-1 text-center font-bold rounded-full mb-4">
          Historique des appels et rendez-vous
        </div>
        <CallCreate :partnerId="partner.id" />
        <PartnerCallsAndEvents :partner-id="partner.id" />
      </div>
      <PartnerEnv :partner-id="partner.id" class="pt-0" />
    </div>
  </div>
</template>
